import { render, staticRenderFns } from "./ContactTags.vue?vue&type=template&id=a514ae30&scoped=true"
import script from "./ContactTags.vue?vue&type=script&lang=js"
export * from "./ContactTags.vue?vue&type=script&lang=js"
import style0 from "./ContactTags.vue?vue&type=style&index=0&id=a514ae30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a514ae30",
  null
  
)

export default component.exports